import { defineComponent, computed } from 'vue';
import __vue_component__ from '../../buttons/ButtonComponent/ButtonComponent.vue.js';
import __vue_component__$1 from '../../symbols/X.vue.js';

var script = defineComponent({
    name: 'Tag',
    components: {
        ButtonComponent: __vue_component__,
        X: __vue_component__$1,
    },
    props: {
        clickable: {
            type: Boolean,
        },
        highlight: {
            type: Boolean,
        },
        iconLeft: {
            type: String,
            default: null,
        },
        iconRight: {
            type: String,
            default: null,
        },
        tagStyle: {
            type: String,
            default: '1-grey',
        },
        to: {
            type: [Object, String],
            default: null,
        },
        tooltip: {
            type: String,
            default: null,
        },
        tooltipPosition: {
            type: String,
            default: null,
        },
    },
    setup(props, { emit }) {
        const classNames = computed(() => {
            const names = [];
            let baseStyle = null;
            let colorStyle = null;
            switch (props.tagStyle) {
                case 'transparent':
                    break;
                case '1-grey':
                    baseStyle = 'Tag--1';
                    colorStyle = 'Tag--1-grey';
                    break;
                case '2-green':
                    baseStyle = 'Tag--2';
                    colorStyle = 'Tag--2-green';
                    break;
                case '3-blue':
                    baseStyle = 'Tag--3';
                    colorStyle = 'Tag--3-blue';
                    break;
                case '3-grey':
                    baseStyle = 'Tag--3';
                    colorStyle = 'Tag--3-grey';
                    break;
                case '3-green':
                    baseStyle = 'Tag--3';
                    colorStyle = 'Tag--3-green';
                    break;
                case '3-orange':
                    baseStyle = 'Tag--3';
                    colorStyle = 'Tag--3-orange';
                    break;
                case '3-purple':
                    baseStyle = 'Tag--3';
                    colorStyle = 'Tag--3-purple';
                    break;
                case '3-red':
                    baseStyle = 'Tag--3';
                    colorStyle = 'Tag--3-red';
                    break;
                case '3-ghost':
                    baseStyle = 'Tag--3';
                    colorStyle = 'Tag--3-ghost';
                    break;
                case '4-black':
                    baseStyle = 'Tag--4';
                    colorStyle = 'Tag--4-black';
                    break;
                case '4-blue':
                    baseStyle = 'Tag--4';
                    colorStyle = 'Tag--4-blue';
                    break;
                case '4-green':
                    baseStyle = 'Tag--4';
                    colorStyle = 'Tag--4-green';
                    break;
                case '4-purple':
                    baseStyle = 'Tag--4';
                    colorStyle = 'Tag--4-purple';
                    break;
                case '5-black':
                    baseStyle = 'Tag--5';
                    colorStyle = 'Tag--5-black';
                    break;
                case '6-grey':
                    names.push('Tag--6', 'Tag--6-grey');
                    break;
                case '7-grey':
                    names.push('Tag--7');
                    break;
            }
            names.push(baseStyle, colorStyle);
            if (props.highlight) {
                names.push('Tag--highlight');
                names.push(`${colorStyle}--highlight`);
            }
            if (props.clickable) {
                names.push('Tag--clickable');
                names.push(`${colorStyle}--clickable`);
            }
            else {
                names.push('Tag--not-clickable');
            }
            return names;
        });
        const handleTagClick = (event) => {
            if (props.clickable)
                emit('click', event);
        };
        return {
            classNames,
            handleTagClick,
        };
    },
});

export { script as default };
